document.addEventListener("DOMContentLoaded", () => {
  const makeSliderScrollable = (slider) => {
    console.log({slider});
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      e.preventDefault();
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    });
  };

  setTimeout(() => {
    if (window.innerWidth >= 768) {
      const menuGlobal = document.querySelector('.header-menu');
      const allMenuMove = document.querySelectorAll(".mega-menu__grid[data-offer]");

      if(menuGlobal) menuGlobal.style.pointerEvents = 'none';

      allMenuMove.forEach((menu, index) => {
        const { offer } = menu.dataset;

        const slidersToMove = menu.querySelectorAll(
          '.collection-list-items-wrapper[data-offer-value="' + offer + '"]'
        );

        slidersToMove.forEach((slider) => {
          menu.insertAdjacentElement("beforebegin", slider);

          const scrollableList = slider.querySelector(".collection-list-items");

          if (scrollableList && window.innerWidth >= 1024) {
            makeSliderScrollable(scrollableList);
            if(index == (allMenuMove.length - 1)) menuGlobal.style.pointerEvents = 'all';
          }
        });

        if(!slidersToMove && index == (allMenuMove.length - 1)) menuGlobal.style.pointerEvents = 'all';
      });

      if(allMenuMove.length == 0) menuGlobal.style.pointerEvents = 'all';
    }
  }, 1500);
});
